import React, { Component, Fragment } from 'react';
import { Box, Button, TextField, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material';

import styles from './styles';
import AxlButton from '../../AxlMUIComponent/AxlButton';

class ReasonDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: null,
      open: false,
    };
  }

  onChange = ({ target: { value } }) => {
    this.setState({ text: value });
    this.props.onChange(value);
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { loading, open } = this.props;

    if (open !== prevProps.open) {
      this.setState({ open: open });
    }
    // close dialog when loading completed
    if (!loading && loading !== prevProps.loading) {
      this.setState({ open: false });
    }
  }

  render() {
    const { open } = this.state;
    const { title, reason, onClose, onConfirm, onChange, confirmText = 'Ok' } = this.props;

    return (
      <Dialog open={open} maxWidth="lg" onClose={onClose} PaperProps={{ sx: styles.dialogPaper }}>
        <DialogTitle sx={styles.dialogTitle}>{title}</DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <TextField multiline label="Reason..." variant="outlined" rows={5} fullWidth value={reason} onChange={this.onChange} margin="dense" />
        </DialogContent>

        <Box display='flex' justifyContent="center" gap={1}>
          <Button variant="outlined" size='small' disableElevation onClick={onClose}>
            Cancel
          </Button>
          <Button variant="contained" size='small' color='primary' disableElevation disabled={!reason} onClick={onConfirm}>
            {confirmText}
          </Button>
        </Box>
      </Dialog>
    );
  }
}

export default ReasonDialog;
